/*
 * Copyright (C) 2025 Hendrik. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 * Written by Hendrik, December 28, 2025.
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UserManagement.css';

export default function SchoolManagement() {
    const [schools, setSchools] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newSchool, setNewSchool] = useState({
        school_name: '',
        school_code: ''
    });
    const [adding, setAdding] = useState(false);

    useEffect(() => {
        fetchSchools();
    }, []);

    const fetchSchools = async () => {
        try {
            setLoading(true);
            const authToken = localStorage.getItem('auth_token');
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/get_schools.php`, {
                headers: {
                    'Authorization': `Bearer ${authToken}`
                }
            });
            if (response.data.success) {
                setSchools(response.data.schools || []);
            }
        } catch (error) {
            alert('Failed to fetch schools');
        } finally {
            setLoading(false);
        }
    };

    const handleAddSchool = async (e) => {
        e.preventDefault();
        if (!newSchool.school_name.trim() || !newSchool.school_code.trim()) {
            alert('Please enter both school name and school code');
            return;
        }

        setAdding(true);
        try {
            const authToken = localStorage.getItem('auth_token');
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/add_school.php`,
                {
                    school_name: newSchool.school_name,
                    school_code: newSchool.school_code
                },
                {
                    headers: {
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            );

            if (response.data.success) {
                alert('School added successfully!');
                setNewSchool({ school_name: '', school_code: '' });
                fetchSchools();
            } else {
                alert('Error adding school: ' + (response.data.error || 'Unknown error'));
            }
        } catch (error) {
            alert('Failed to add school: ' + (error.response?.data?.error || error.message));
        } finally {
            setAdding(false);
        }
    };

    const handleDeleteSchool = async (schoolId, schoolName) => {
        if (!window.confirm(`Are you sure you want to delete "${schoolName}"? This will delete all associated data.`)) {
            return;
        }

        try {
            const authToken = localStorage.getItem('auth_token');
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/delete_school.php`,
                { school_id: schoolId },
                {
                    headers: {
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            );

            if (response.data.success) {
                alert('School deleted successfully!');
                fetchSchools();
            } else {
                alert('Error deleting school: ' + (response.data.error || 'Unknown error'));
            }
        } catch (error) {
            alert('Failed to delete school: ' + (error.response?.data?.error || error.message));
        }
    };

    if (loading) {
        return <div className="users-container"><p>Loading schools...</p></div>;
    }

    return (
        <div className="users-container" style={{ marginLeft: '20%', marginRight: '5%' }}>
            <h1>School Management</h1>

            <div className="form-section" style={{ marginBottom: '30px', padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '8px', maxWidth: '600px' }}>
                <h3>Add New School</h3>
                <form onSubmit={handleAddSchool}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                        <input
                            type="text"
                            placeholder="School Name"
                            value={newSchool.school_name}
                            onChange={(e) => setNewSchool({ ...newSchool, school_name: e.target.value })}
                            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                        />
                        <input
                            type="text"
                            placeholder="School Code (e.g., SCH_001)"
                            value={newSchool.school_code}
                            onChange={(e) => setNewSchool({ ...newSchool, school_code: e.target.value })}
                            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={adding}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontWeight: 'bold'
                        }}
                    >
                        {adding ? 'Adding...' : 'Add School'}
                    </button>
                </form>
            </div>

            <div className="table-section">
                <h3>Schools List</h3>
                <table className="users-table">
                    <thead>
                        <tr>
                            <th>School Name</th>
                            <th>School Code</th>
                            <th>Created At</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {schools.map((school) => (
                            <tr key={school.id}>
                                <td>{school.school_name}</td>
                                <td><code>{school.school_code}</code></td>
                                <td>{new Date(school.created_at).toLocaleDateString()}</td>
                                <td>
                                    <button
                                        onClick={() => handleDeleteSchool(school.id, school.school_name)}
                                        style={{
                                            padding: '6px 12px',
                                            backgroundColor: '#f44336',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '12px'
                                        }}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {schools.length === 0 && <p style={{ color: '#999', marginTop: '10px' }}>No schools found.</p>}
            </div>
        </div>
    );
}
